import { css } from 'styled-components';
const styles = css `
  img {
    position: fixed;
    top: calc(50% - 50px);
    left: 50%;
    transform translate(-50%, -50%);
    width: 160px;
  }
`;
export default styles;
